<template>
  <div>
    <div id="knowledgVideoList" v-if="showPage">
      <div class="carousel-container" id="carousel">
        <div class="indicationBtn" @click="openIndicatonList">
          <i class="icon iconfont iconshuqian" style="color: #EF1201;font-size: 26px!important;"></i>
        </div>
        <div class="indicationList" v-show="showIndicationList">
          <div style="text-align: center;margin-bottom: 5px;">筛选您感兴趣的适应症</div>
          <ul>
            <li v-for="(item, index) in indicationList" :key="index" :class="{'active':item.checked}" @click="chooseIndicatons(item)">{{item.name}}</li>
          </ul>
        </div>
        <swiper
          id="carousel-list"
          v-if="myList.length > 0"
          :options="swiperOption"
          ref="mySwiper"
          class="carousel-list">
            <swiper-slide  class="my-swp-silde" v-for="(slide, index) in myList" :key="index" data-id="slide.id" @click.native="goJumpLink(slide)">
                <img class="my-swp-img" :src="baseUrl + '/api/RotationChart/GetFile?filepath=' + encodeURIComponent(slide.picturePath)" alt="">
                <div class="my-slide-name">{{slide.name}}</div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="main-container">
        <div class="tabList">
          <template v-if="tablist.length > 0">
            <ul>
              <li v-for="(item, index) in tablist" :key="index" :class="{'activeTab': item.active}" @click="switchTab(item, index)">{{item.name}}</li>
            </ul>
            <template v-for="(item, index) in tablist">
              <div :key="index" v-if="currentTab.id == item.id && showVideos" :style="'height:' + (screenHeight - carouselHeight - 50) + 'px;'">
                <iframe
                  :ref="'video' + item.id"
                  :style="'height:' + (screenHeight - carouselHeight - 50) + 'px;'"
                  allowfullscreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  id="brightCoveVideo"
                  name="mainIframe"
                  :src="`https://players.brightcove.net/3871979173001/experience_${currentTab.galleryId}/index.html?bcemail=${openId}&bctrackingid=${openId}&bccustomguid=${openId}`"
                  frameborder="0"
                  scrolling="auto">
                </iframe>
              </div>
            </template>
          </template>
          <div v-else style="text-align:center; height: calc(75vh - 77px);margin-top: 50px;">{{noDataText}}</div>
        </div>
      </div>
    </div>
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
import agreeBookDialog from "./agreeBookDialog";
import merge from 'webpack-merge';
import avatar from '@/assets/loading.gif'
export default {
  name: 'knowledgVideoList',
  components: { swiper, swiperSlide,agreeBookDialog },
  data () {
    return {
      showPage: false,
      ABDialogShow:false,
      baseUrl: process.env.config.baseUrl,
      showIndicationList: false,
      indicationList: [],
      currentTab: {},
      tablist: [],
      searchData: {
        name: '',
        fieldId: '',
        indicationId: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      swiperOption: {
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      userInfo: {},
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      needReturn: this.$route.query.needReturn || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      showVideos: false,
      noDataText: '',
      screenHeight: 600,
      carouselHeight: 150,
      showGuide: false
    }
  },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/knowledgVideoList?returnurl=' + encodeURIComponent((this.oriUrl || '')))
   window.location.href = url
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      // process.env.config.baseUrl
      // window.location.host
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/knowledgVideoList?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      // this.$axiox.get(url).then(msg => {
      //   console.log(msg)
      // })
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }

          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  // 获取用户信息
                  this.getUserInfo()
                } else {
                  // this.$commonJs.closeWindow()
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                // 获取用户信息
                this.getUserInfo()
              } else {
                // this.$commonJs.closeWindow()
                this.showGuide = true
              }
            }
          }
        })
      }
    }
    // if (!this.$route.query.openid) {
    //   // process.env.config.baseUrl
    //   // window.location.host
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/knowledgVideoList?returnurl=' + encodeURIComponent((this.oriUrl || '')))
    //   // this.$axiox.get(url).then(msg => {
    //   //   console.log(msg)
    //   // })
    //   window.location.href = url
    // } else {
    //   this.openId = this.$route.query.openid
    //   let isEmployee = window.localStorage.getItem('isEmployee')
    //   let requestUrl = ''
    //   if (isEmployee) {
    //     requestUrl = '/api/wechat/getEmployee/'
    //   } else {
    //     requestUrl = '/api/wechat/getDoctor/'
    //   }
    //   this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
    //     console.log(msg, 'getDoctor')
    //     if (msg.isSuccess) {
    //       if (msg.data.status === 2) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       }
    //       else if (msg.data.status === 3) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else {
    //         if (msg.data.isFollowed) {
    //           this.showPage = true
    //           // 获取用户信息
    //           this.getUserInfo()
    //         } else {
    //           // this.$commonJs.closeWindow()
    //           this.showGuide = true
    //         }
    //       }
    //     }
    //   })
    // }

    setTimeout(() => {
    this.getSignDetail();
    this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
    }, 1000);


  },
  mounted () {
    document.title = '视频学院'
    // current swiper instance
    // console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
    // id="carousel-list"
    let swiperDom = document.getElementById('carousel-list')
    console.log(swiperDom, 'swiperDom')
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    // 获取用户信息
    getUserInfo () {
      let isEmployee = window.localStorage.getItem('isEmployee')
      let requestUrl2 = ''
      if (isEmployee) {
        requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
      } else {
        let data = {
          openId: this.openId
        }
        requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
      }
      requestUrl2.then(msg => {
        console.log(msg, 'msg')
        if (msg.isSuccess) {
          this.userInfo = msg.data
          if (msg.data.fields && msg.data.fields.length > 0) {
            let fields = msg.data.fields.map(val => {
              return val.id
            })
            // 获取适应症
            this.getIndicationsList(fields)
          } else {
            console.log(this.userInfo.departmentId, '通过科室查找领域')
            // 通过科室查找领域
            let department = this.userInfo.department ? this.userInfo.department : ''
            this.getFieldsList(department, this.getIndicationsList)
          }
        }
      })
    },
    // 获取轮播图列表
    getList (obj) {
      let params = JSON.parse(JSON.stringify(obj))
      params.paged.pageSize = 0 // 后端配置
      this.$axiox.get(`/api/RotationChart/GetTimeLength`).then(t => {
        // 轮播图时长
        let time = t
        this.$axiox.post(`/api/RotationChart/Query`, params).then(res => {
          console.log(res, 'getList')
          if (res && res.data) {
            this.myList = res.data
            console.log(this.myList, 'myList')
          } else {
            this.myList = []
            console.log(this.myList, 'myList')
          }
          this.swiperOption.autoplay = {
            delay: time, // 轮播图时长
            stopOnLastSlide: false,
            disableOnInteraction: false
          }
          this.$nextTick(() => {
            this.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            console.log(this.screenHeight, 'this.screenHeight')
            setTimeout(t => {
              this.carouselHeight = document.getElementById('carousel').offsetHeight
              console.log(this.carouselHeight, 'this.carouselHeight')
            }, 300)
          })
        })
      })
    },
    // 获取项目列表
    getTabList (params) {
      this.$axiox.post(`/api/VideoManagement/Query`, params).then(res => {
        console.log(res, 'getTabList')
        // this.coverGif()
        if (res.data) {
          this.tablist = res.data.map(item => {
            return {
              active: false,
              ...item
            }
          })
          this.tablist[0].active = true
          this.currentTab = this.tablist[0]
          this.showVideos = true
        } else {
          this.tablist = []
          this.currentTab = {}
          this.showVideos = false
          this.noDataText = '更多精彩内容，敬请期待！'
        }
        // let that = this
        // this.$nextTick(() => {
        //   setTimeout(t => {
        //     let iframe = document.getElementById('brightCoveVideo')
        //     console.log(iframe, 'brightCoveVideo----brightCoveVideo')
        //     if (iframe.attachEvent){
        //       iframe.attachEvent("onready", function(){
        //         console.log('1111111111111111')
        //         that.disCover()
        //       })
        //     } else {
        //       iframe.onready = function(){
        //         console.log('222222222222222222222')
        //         that.disCover()
        //       }
        //     }
        //   }, 300)
        // })
      })
    },
    openIndicatonList () {
      this.showIndicationList = !this.showIndicationList
    },
    chooseIndicatons (item) {
      item.checked = !item.checked
      if (this.userInfo.indications && this.userInfo.indications.length > 0) {
        let feildIds = this.userInfo.fields.map(val => val.id)
        console.log(feildIds, 'feildIds----chooseIndicatons---1')
        let flag = this.indicationList.some(item => item.checked)
        console.log(flag, 'flag')
        let indicationsId = []
        if (flag) {
          indicationsId = this.indicationList.filter(val => val.checked).map(val => val.id)
        } else {
          indicationsId = this.indicationList.map(val => {
            return val.id
          })
        }
        let params = {
          name: '',
          fieldId: feildIds,
          indicationId: indicationsId,
          paged: {
            pageIndex: 1,
            pageSize: 999
          }
        }
        // 获取项目列表
        this.getTabList(params)
      } else {
        let feildIds = []
        if (this.userInfo.fields && this.userInfo.fields.length > 0) {
          feildIds = this.userInfo.fields.map(val => val.id)
          console.log(feildIds, 'feildIds----chooseIndicatons---2')
        } else {
          feildIds = this.fieldsList.map(val => val.id)
          console.log(feildIds, 'feildIds----chooseIndicatons---3')
        }
        let indicIds = this.indicationList.filter(val => val.checked).map(val => val.id)
        console.log(indicIds, 'indicIds----chooseIndicatons')
        let params = {
          name: '',
          fieldId: feildIds,
          indicationId: indicIds,
          paged: {
            pageIndex: 1,
            pageSize: 999
          }
        }
        // 获取项目列表
        this.getTabList(params)
      }
    },
    switchTab (item, index) {
      // this.coverGif()
      this.currentTab = item
      console.log(this.currentTab, 'this.currentTab')
      for(let i = 0; i < this.tablist.length; i++) {
        if (index == i) {
          this.tablist[i].active = true
        } else {
          this.tablist[i].active = false
        }
      }
      console.log(window.parent.document.getElementById('brightCoveVideo').src, 'brightCoveVideo.src')
      // let that = this
      // this.$nextTick(() => {
      //   setTimeout(t => {
      //     let iframe = document.getElementById('brightCoveVideo')
      //     console.log(iframe, 'brightCoveVideo----brightCoveVideo')
      //     if (iframe.attachEvent){
      //       iframe.attachEvent("onload", function(){
      //         that.disCover()
      //       })
      //     } else {
      //       iframe.onload = function(){
      //         that.disCover()
      //       }
      //     }
      //   }, 300)
      // })
    },
    goJumpLink (item) {
      console.log(item,'goJumpLink')
      window.location.href = item.jumpLink
    },
    // 通过科室获取领域
    getFieldsList (department, cb) {
      let url = ''
      if (department) {
        url = `/api/Dict/GetFields?deptName=${department}`
      } else {
        url = `/api/Dict/GetFields`
      }
      this.$axiox.get(url).then(res => {
        console.log(res, 'getFieldsList')
        this.fieldsList = res
        if (cb) {
          let ids = this.fieldsList.map(val => {
            return val.id
          })
          cb(ids)
        }
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      console.log(ids, 'ids-------99999999999')
      if (this.userInfo.indications && this.userInfo.indications.length > 0) {
        // 如果用户选择了适应症
        this.indicationList = this.userInfo.indications.map(val => {
          return {
            checked: true,
            ...val
          }
        })
        let indicationsId = this.userInfo.indications.map(val => {
          return val.id
        })
        let params = {
          name: '',
          fieldId: ids,
          indicationId: indicationsId,
          paged: {
            pageIndex: 1,
            pageSize: 999
          }
        }
        // 获取项目列表
        this.getTabList(params)
        // 获取轮播图列表
        this.getList(params)
      } else {
        // 如果没有选择适应症
        this.$axiox.post(`/api/Dict/GetIndications`, ids).then(res => {
          this.indicationList = res.map(val => {
            return {
              checked: false,
              ...val
            }
          })
          let params1 = {
            name: '',
            fieldId: ids,
            indicationId: [],
            paged: {
              pageIndex: 1,
              pageSize: 999
            }
          }
          // 获取项目列表
          this.getTabList(params1)
          // 获取轮播图列表
          this.getList(params1)
        })
      }
    },
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  },
  computed: {
    swiper () {
      this.$nextTick(() => {
        return this.$refs.mySwiper.swiper
      })
    }
  }
}
</script>

<style scoped>
  .carousel-container {
    width: 100vw;
    min-width: 300px;
    min-height: 150px;
    position: relative;
  }
  .myimg {
    display: block;
    width: 100%;
  }
  .indicationBtn {
    width: 45px;
    height: 45px;
    line-height: 45px;
    border-radius: 50%;
    position: absolute;
    top: 15px;
    right: 5px;
    background-color: #ffffff;
    text-align: center;
    z-index: 3;
  }
  .indicationList {
    width: 170px;
    height: 120px;
    min-height: 120px;
    position: absolute;
    top: 15px;
    right: 60px;
    padding: 15px;
    background: rgba(255,255,255, 0.8);
    border-radius: 10px;
    border: 1px solid #C5C5C5;
    overflow: auto;
    z-index: 3;
  }
  .indicationList ul {
    width: 100%;
    margin: 0 auto;
  }
  .indicationList ul li {
    width: 100%;
    /* height: 30px; */
    height: auto;
    /* line-height: 30px; */
    background-color: #ffffff;
    border: 1px solid #C5C5C5;
    color: #666666;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;
    margin-top: 15px;
    padding: 5px 0;
  }
  .indicationList ul li.active {
    color: #EF1201;
    border: 1px solid #EF1201;
  }
  .carousel-list {
    width: 100%;
    /* height: 25vh; */
    height: auto;
  }
  .my-swp-silde {
    width: 100%;
    position: relative;
  }
  .my-swp-silde .my-swp-img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active {
    background: #EF1201!important;
  }
  .my-slide-name {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    background-color: rgba(255,255,255, 0.5);
    color: #333333;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .main-container {
    width: 100vw;
    /* height: calc(100vh - 200px); */
  }
  #brightCoveVideo {
    width: 100%;
    min-height: 400px;
  }
  .tabList {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 2px 2px 8px #C5C5C5;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .tabList ul {
    width:100%;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    overflow-x: auto;
    overflow-y: hidden;
    text-align: center;
  }
  .tabList ul li {
    width: auto;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    margin-left: 15px;
  }
  .tabList ul li:first-child {
    margin-left: 0;
  }
  .tabList ul li.activeTab {
    color: #EF1201;
    border-bottom: 2px solid #EF1201;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/knowledgVideoList.vue